import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Group from '@spa/shared/components/Filters/Group';
import CheckboxFilter from '@spa/shared/components/Filters/Checkbox';
import { MediaContext } from '@spa/shared/contexts/media';

const Place = ({ fields, onChangeEventHandler, onChangeEventForceArrayHandler }) => {
  const { t } = useTranslation('translations');
  const { is } = useContext(MediaContext);

  const rentType = fields['rent-type'];
  const housingType = fields['housing-type'];

  return (
    <Group title={t('filters.sections.places')}>
      <CheckboxFilter
        name="rent-type"
        value="property"
        onChange={onChangeEventHandler}
        selected={rentType && (rentType.includes('property') || rentType.includes('entire-house'))}
        label={t('filters.labels.entireProperty')}
      />
      <CheckboxFilter
        name="rent-type"
        value="unit"
        onChange={onChangeEventHandler}
        selected={rentType && (rentType.includes('unit') || rentType.includes('private-bedroom'))}
        label={t('filters.labels.bedroom')}
      />
      <CheckboxFilter
        name="rent-type"
        value="subunit"
        onChange={onChangeEventHandler}
        selected={rentType && (rentType.includes('subunit') || rentType.includes('shared-bedroom'))}
        label={t('filters.labels.sharedBedroom')}
      />
      {is.mobile ? (
        <CheckboxFilter
          isResidence
          isNew
          name="housing-type"
          value="residence"
          onChange={onChangeEventForceArrayHandler}
          selected={housingType && housingType.includes('residence')}
          label={t('filters.labels.studentResidence')}
        />
      ) : null}
    </Group>
  );
};

Place.propTypes = {
  fields: PropTypes.object.isRequired,
  onChangeEventHandler: PropTypes.func.isRequired,
  onChangeEventForceArrayHandler: PropTypes.func.isRequired
};

export default Place;
